import { api } from ".";
import { BASE_URL, DOMAIN } from "../utils/constants";

// export const getForm = async ({ name }) => {
//   return await api.get("/wfm/web-form", {
//     "filter[name]": name,
//   });
// };
export const getForm = async ({ name }) => {
  return await api.get("/wfm/form", {
    "filter[name]": name,
  });
};
export const getMerchant = async () => {
  return await api.get(`/crm/integration/viewMerchantV3`, {
    "domain": DOMAIN,
  });
};
// export const getForm = async ({ name }) => {
//   return await api.get("/wfmservice/form", {
//     "filter[name]": name,
//   });
// };


export const postForm = async ({ token, data, tenantId = null }) => {
  const url = data.is_internal
    ? "/wfm/form/create-work-order-internal"
    : "/wfm/form/create-work-order";
  
  //bedc-wfm-staging.convergenceondemand.net/wfmservice/form

  if (data.is_internal && tenantId) {
    api.setHeaders({
      "Tenant-ID": tenantId,
    });
  }

  https: api.setHeaders({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  });

  return await api.post(url, data);
};

export const uploadFiles = async ({ token, data }) => {
  api.setHeaders({
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
  });
  return await api.post("/wfm/web-form/work-order-attachment", data);
};
